import React from 'react'
// import PropTypes from 'prop-types'
// import styled from 'styled-components'
import get from 'lodash/get'
import { ResourceUtilButton } from './resource-utilization'

export default class ButtonGroup extends React.Component {
  render() {
    const submitTab = get(this.props, 'submitTab')
    switch (submitTab) {
      case 2: return (
        <ResourceUtilButton
          exportEfficiencyLOB={ get(this.props, 'exportEfficiencyLOB') }
          handleSearchResource={ get(this.props, 'handleSearchResource') }
        />
      )
      default: return null
    }
  }
}

// Tab.propTypes = {
//   isFetching: PropTypes.bool,
//   isEdit: PropTypes.bool,
// }
// Tab.defaultProps = {
//   isFetching: false,
//   isEdit: false,
// }




// WEBPACK FOOTER //
// ./src/components/efficiency-resource/tab-content/lob-submit/tab/button-group/index.js